import classNames from "shared/utils/classNames";
import { ReactComponent as CallbackButtonIcon } from "assets/images/icons/callback-button-icon.svg";

import ButtonClose from "./ButtonClose";
import ButtonResetChat from "./ButtonResetChat";
import { Props } from "./types";

function TopBarNonIframe(props: Props) {
  const {
    botInfo,
    handleOnRequestCallbackClick,
    resetChat,
    messagesLength,
    startAgainLabel,
    showRequestCallbackButton,
    setIsResetChatModalOpen,
    setIsEndChatModalOpen,
    setIsCloseWidgetAfterEndChat,
    copyTexts,
    customTopBar,
  } = props;

  const collapsedBarMode = messagesLength > 1;

  return (
    <div className="top-bar-container border-b-[var(--borderColor)] bg-[var(--chatBotColor)]">
      <div className="border-0 border-b border-solid border-[var(--borderColor)] p-4">
        <div className="relative">
          {customTopBar ? (
            <>{customTopBar}</>
          ) : (
            <>
              {showRequestCallbackButton && (
                <button
                  onClick={handleOnRequestCallbackClick}
                  className="group border-none bg-transparent"
                >
                  <CallbackButtonIcon className="bg-transparent text-[var(--invertedColor)]" />
                </button>
              )}
              <div
                className={classNames(
                  "flex gap-3",
                  botInfo.bot_info_config.chatbot_subheading
                    ? "items-start"
                    : "items-center",
                  collapsedBarMode && showRequestCallbackButton && "mt-10",
                  !collapsedBarMode && "hidden",
                )}
              >
                <img
                  className="h-10 w-10"
                  alt="Company logo"
                  src={botInfo.bot_info_config.company_logo}
                />
                <div className="text-[var(--invertedColor)]">
                  <p className={classNames("font-semibold leading-6")}>
                    {botInfo.bot_info_config.company_name}
                  </p>
                  {botInfo.bot_info_config.chatbot_subheading && (
                    <p className="mt-1 text-xs">
                      {botInfo.bot_info_config.chatbot_subheading}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}
          {collapsedBarMode && (
            <ButtonResetChat
              botInfo={botInfo}
              resetChat={resetChat}
              setIsResetChatModalOpen={setIsResetChatModalOpen}
              startAgainLabel={startAgainLabel}
            />
          )}
          <ButtonClose
            botInfo={botInfo}
            collapsedBarMode={collapsedBarMode}
            setIsEndChatModalOpen={setIsEndChatModalOpen}
            setIsCloseWidgetAfterEndChat={setIsCloseWidgetAfterEndChat}
            copyTexts={copyTexts}
          />
        </div>
        {collapsedBarMode ? null : (
          <div className="my-5 flex flex-col items-center">
            <img
              className="h-16 w-16 p-3"
              alt="Company logo"
              src={botInfo.bot_info_config.company_logo}
            />
            <div className="max-w-full break-words px-2 text-center font-bold leading-8 text-[var(--invertedColor)]">
              {botInfo.bot_info_config.company_name}
            </div>
            {botInfo.bot_info_config.chatbot_subheading && (
              <p className="max-w-full break-words text-sm leading-5 text-[var(--invertedColor)]">
                {botInfo.bot_info_config.chatbot_subheading}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default TopBarNonIframe;
